<template>
  <div class="main">
    <div class="scroll-box" :style="viewStyleObj" ref="scrollBox">
      <img class="title-img" v-if="tmpType ==2 " src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/91/rB8LrmU3ODGAMiepAAOXLLaC1Ug815.png" alt="" />
      <img class="title-three" v-if="tmpType==3" src="https://img3.quanyou.com.cn/joyNew/group1/M00/22/A4/rB8LrmVkZ8CAUbQAAAH21b2Lkc0974.png" alt="" />
      <img class="title-five" v-if="tmpType==5" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1E/57/rB8LrWU_ChCAOa0CAAIbyZSLbvc587.png" alt="" />
      <main class="content">
        <van-image class="introduction" width="78" height="28" :src="introImg" v-if="isShowIntroduction"></van-image>
        <red-packet-rolling v-if="isShowRedPacketRolling" />
        <template v-for="comItem in comList">
          <component :is="dynamicComs[comItem.comType]" :key="comItem.comId" :comData="comItem.formData" :isLottery="isLottery" :tmpType="tmpType-1"></component>
        </template>
      </main>
    </div>
    <footer>
      <div class="footer-btn plain" @click="goback">返回</div>
      <!-- <div class="footer-btn plain" v-if="!activityInfo.activityId">保存</div> -->
      <div class="footer-btn plain" v-if="isPreivew && activityInfo.activityStatus == 0" @click="releaseActivity">发起活动</div>
      <div class="footer-btn plain" v-if="isShowInviteBtn" @click="inviteStore">邀请门店</div>
      <div class="footer-btn plain" v-if="isShowJoinBtn" @click="joinActivity">立即参与</div>
      <div class="footer-btn plain" v-if="isShowPoster" @click="showPoster">海报分享</div>
    </footer>

    <invitation-code 
      v-if="isShowDialog" 
      :visible.sync="isShowDialog"
      :invitationData="invitationData" />
  </div>
</template>

<script>
import IntroPic from '@/assets/images/img-ppjs@2x.png'
import TopImage from './components/top-image'
import SignUp from './components/sign-up'
import Attention from './components/attention'
import ImageVideo from './components/image-video'
import Store from './components/store'
import InvitationCode from './components/invitation-code'
import RedPacketRolling from './components/red-packet-rolling'
import Lottery from './components/lottery'
import LiveReserve from './components/live-reserve'
import Question from './components/question'
import Spike from './components/spike'
import ConnectPic from './components/connect-pic'
import GroupBuy from './components/group-buy'
import drawLots from './components/drawLots'
import styleTest from './components/style-test'
import countMoney from './components/count-money'
import coupon from './components/coupon/coupon.vue'


import loadingMixin from '@/mixins/loading-mixin'
import {isString} from '@/utils/utils'
import {wxPay} from '@/utils/wxPay'
import { mapGetters } from 'vuex'
import { luckDrawData } from "../activity-management/utils"
import { configShareInfo } from '@/utils/wxApi'
const mapHomeBackgroundImg = [ 
  'https://img3.quanyou.com.cn/joy/group1/M00/10/0D/rB4ChmJ530GAThsuAADDrxD5tQA440.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/1E/rB8LrmUx9JuAQDWuAA4vdldUFEM256.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/22/C7/rB8LrWVldWOAFeMlABm54FI-e2c244.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/CE/rB8LrmU5v56Afqb4ABIQ6sZQDpQ047.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/1E/56/rB8LrmU_BleAIENXAApiZAoTTeY706.png'
]
export default {
  name: 'ActivityHome',
  mixins: [loadingMixin],
  components: {
    TopImage,
    SignUp,
    Attention,
    ImageVideo,
    Store,
    InvitationCode,
    RedPacketRolling,
    Lottery,
    LiveReserve,
    Question,
    Spike,
    ConnectPic,
    GroupBuy,
    drawLots,
    styleTest,
    countMoney,
    coupon
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo'
    ]),
    tmpType() {
      return this.$route.query.tmpType || '1'
    },
    isPreivew() {
      return this.$route.query.isPreview == 1;
    },
    isJoin() {
      return this.$route.query.from == 'join';
    },
    // 品牌介绍
    isShowIntroduction() {
      const configItems = this.activityInfo.activityConfig;
      if (!Array.isArray(configItems)) {
        return;
      }
      return configItems.some(item => item.configCode === 'boolShowIntro' && item.configValue === 'true');
    },
    previewData() {
      return this.$store.state.createParam;
    },
    // 显示邀请按钮
    isShowInviteBtn() {
      // 活动老师 + 我创建的 + 活动已发布
      return this.isTeacher 
        && this.$route.query.activityTag == 1
        && +this.activityInfo.activityStatus > 0;
    },
    // 显示加入按钮 
    isShowJoinBtn() {
      // (经销商，店长角色）+ 未加入 + 扫一扫邀请门店
      return (this.isShopowner || this.isDistributor) 
        && this.activityInfo.isJoined != 1
        && this.$route.query.from == 'join';
    },
    // 显示海报
    isShowPoster() {
      //（经销商, 店长，导购）+ 活动已发布 + 首页查看活动
      return (this.isShopowner || this.isDistributor || this.isGuide)
        && this.activityInfo.activityStatus == 1
        && (this.$route.query.from == 'home' || this.$route.query.from == 'manager');
    },
    viewStyleObj() {
      return {
        backgroundImage: `url(${mapHomeBackgroundImg[this.tmpType-1]})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
      }
    },
  },
  data() {
    return {
      isFirstEntry: true,
      introImg: IntroPic,
      dynamicComs: {
        picture: TopImage,
        'sign-up': SignUp,
        'image-text-detail': ImageVideo,
        store: Store,
        attention: Attention,
        lottery: Lottery,
        'live-reserve': LiveReserve,
        question: Question,
        spike: Spike,
        connectPic: ConnectPic,
        groupBuying: GroupBuy,
        drawLots: drawLots,
        style: styleTest,
        countMoney: countMoney,
        coupon: coupon
      },
      // 模板包含的组件列表
      comList: [],
      activityInfo: {},
      basicInfo: {},
      // 邀请数据
      invitationData: {},
      isShowDialog: false,
      isShowRedPacketRolling: false,
      isLottery: false,
    }
  },
  methods: {
    async init() {
      this.showLoading();
      let activityData = {};
      if (this.$route.query.activityId) {
        // 加入活动
        if (this.isJoin) {
          activityData = await this.getJoinActivityInfo();
        } else {
          // 保存后预览, 首页查看活动
          activityData = await this.getActivityInfo();
        }
      } else {
        // 未保存预览
        activityData = this.previewData;
      }
      this.activityInfo = activityData;
      const {activityTitle, startTime, endTime, activityModule, activityId, activityAppend} = activityData;
      this.basicInfo = {
        activityId,
        activityTitle,
        startTime,
        endTime
      };
      this.initComponentList(activityModule);
      this.initRedpacketConf(activityAppend);
      this.hideLoading();
      if (this.isJoin) {
         // 活动结束
        if (activityData.status == 3) {
          this.$dialog.alert({
            message: '当前活动已经结束，无法参与当前活动',
          }).then(res => {
            this.$router.go(-1)
          })
        }else if (this.isFirstEntry) {
          this.isFirstEntry = false
          if (!this.isShowJoinBtn) {
            this.$dialog.alert({
              message: '当前已参与过活动，请勿重复扫码参与！',
            }).then(res => {
              this.$router.go(-1)
            })
          }
        }
      }
    },
    initComponentList(comModules) {
      if (!Array.isArray(comModules)) {
        return;
      }

      const comList = [];
      comModules.forEach(moduleItem => {
        let formData = {};
        switch (moduleItem.moduleType) {
          case 'sign-up':
            formData = {
              ...this.basicInfo,
              // 是否是预览
              isPreview: this.isPreivew,
              // 是否已参与
              isJoin: this.activityInfo.isJoined
            };
            moduleItem.activityModuleDetail.forEach(item => {
              formData[item.moduleDetailCode] = isString(item.moduleDetailCode) && item.moduleDetailCode.startsWith('bool') 
                ? item.moduleDetailValue === 'true'
                : item.moduleDetailValue;
            });
            moduleItem.activityModuleSetup.forEach(item => {
              formData[item.setupColumn] = isString(item.setupColumn) && item.setupColumn.startsWith('bool') 
                ? item.setupColumnValue === 'true'
                : item.setupColumnValue;
            })
            break;
          case 'attention':
            moduleItem.activityModuleDetail.forEach(item => {
              formData[item.moduleDetailCode] = isString(item.moduleDetailCode) && item.moduleDetailCode.startsWith('bool') 
                ? item.moduleDetailValue === 'true'
                : item.moduleDetailValue;
            })
            break;
          case 'picture':
          case 'image-text-detail':
            formData = moduleItem.activityModuleDetail.map(item => ({
              moduleDetailValue: item.moduleDetailValue,
              detailDataType: item.detailDataType
            }));
            break;
          case 'lottery':
            formData = luckDrawData(moduleItem)
             // 查找抽奖方式 没有找到默认九宫格
            formData.lotteryMode = moduleItem.activityModuleSetup.find(item => item.setupColumn == 'lotteryMode').setupColumnValue || 'lottery-9'
            // 是否预览
            formData.isPreview = this.isPreivew
            this.isLottery = true
            break
          case 'live-reserve':
            formData = this.initLiveData(moduleItem)
            break 
          case 'question':
            formData = moduleItem.activityModuleDetail.map(item => ({
              moduleDetailValue: item.moduleDetailValue,
              detailDataType: item.detailDataType
            }));
            break
          case 'spike':
            formData = {
              activityId: moduleItem.activityId,
              spikeSections: moduleItem.spikeSections,
            }
            break
          case 'connectPic':
            formData = moduleItem.connectPic
            break
          case 'groupBuying':
            formData = moduleItem.groupBuyingVO ||  moduleItem.groupBuying
            break
          case 'drawLots' :
            formData = {}
            break
          case 'style' :
            formData = moduleItem.stylePageMain
            break
          case 'countMoney' :
            formData = {}
            break
          case 'coupon' :
            formData = moduleItem.couponModule
            break
          default:
            break;
        }
        comList.push({
          comId: moduleItem.moduleId,
          comType: moduleItem.moduleType,
          formData
        });
      });
      this.comList = comList;
    },
    initLiveData(moduleItem) {
      let formData = {}
      moduleItem.activityModuleDetail.forEach(item => {
        formData[item.moduleDetailCode] = item.moduleDetailValue
      })
      return formData
    },
    initRedpacketConf(appendModules) {
      if (!Array.isArray(appendModules)) {
        return;
      }
      const redPacketModule = appendModules.find(module => module.appendName === 'redPacket');
      if (!redPacketModule) {
        return;
      }

      const isShowRollingConf = redPacketModule.activityAppendElement.find(item => item.elementCode === 'boolRedPacketRolling');
      if (!isShowRollingConf) {
        return;
      }
      this.isShowRedPacketRolling = isShowRollingConf.elementValue === 'true';
    },

    getActivityInfo() {
      return this.$api.activityMgmt.getActivityInfoById(this.$route.query.activityId)
        .then(({data}) => {
          if (!data) {
            return {};
          }
          return data;
        })
        .catch(err => {
          console.log(err);
          return {};
        });
    },
    getJoinActivityInfo() {
      return this.$api.activityMgmt.getJoinActivityInfoById(this.$route.query.activityId)
        .then(({data}) => {
          if (!data) {
            return {};
          }
          const {activity} = data;
          return {
            ...activity,
            // 是否已参与
            isJoined: data.isJoined
          };
        })
        .catch(err => {
          console.log(err);
          return {};
        });
    },
    goback() {
      this.$router.go(-1);
    },
    inviteStore() {
      let signUpFee = 0;
      const signUpModule = this.activityInfo.activityModule.find(item => item.moduleType === 'sign-up');
      if (signUpModule) {
        const feeItem = signUpModule.activityModuleDetail.find(item => item.moduleDetailCode === 'signUpfee');
        signUpFee = feeItem && feeItem.moduleDetailValue || 0;
      }

      this.invitationData = {
        ...this.basicInfo,
        inviteeId: this.userInfo.id,
        invitee: this.userInfo.realName,
        signUpFee
      }

      this.isShowDialog = true;
    },
    showPoster() {
      if (this.activityInfo.status != 3) {
        this.$router.push({
          path: '/activity/promotion-poster',
          query: {
            activityId: this.activityInfo.activityId
          }
        });
      }else {
        this.$toast('当前活动已经结束，无法操作');
      }
     
    },
    joinActivity() {
      // this.showLoading();
      this.$api.activityMgmt.joinActivity(this.activityInfo.activityId)
        .then(() => {
          this.$toast({
            message: '参与成功！',
            duration: 4000
          })
          setTimeout(() => {
            this.init();
          },2000)
          
        })
        // .finally(_ => {
        //   this.hideLoading();
        // });
    },
    async releaseActivity() {
      const activityId = this.activityInfo.activityId;
      if (!activityId) {
        return;
      }
      this.showLoading();
      // 检查是否需要支付
      const {data: checkRes} = await this.$api.activityMgmt.getPayInfoBeforeRelease(activityId)
        .catch(console.log);
      this.hideLoading();

      // 唤起微信支付
      if (checkRes.wxPayOrderResult) {
        wxPay(checkRes.wxPayOrderResult)
          .then(_ => {
            this.release(activityId, '');
          });
      } else {
        this.release(activityId, '');
      }
    },
    release(activityId, orderNo) {
      const params = {
        activityId,
        orderNo
      };
      return this.$api.activityMgmt.releaseActivity(params)
        .then(() => {
          this.$router.push('/home');
        })
        .catch(console.log);
    }
  },
  created() {
    this.isFirstEntry = true
    this.init();
    configShareInfo({title: '这是分享标题1',desc: '这是描述1', link:'weixin://dl/business/?t=TkgJd6gqOBf',imgUrl: ''})
  }
}
</script>

<style lang="stylus" scoped>
.main
  .scroll-box
    position relative
    height: calc(100vh - 64px)
    overflow-y auto
    // background: $bgGradientColor
    background: url('https://img3.quanyou.com.cn/joy/group1/M00/10/0D/rB4ChmJ530GAThsuAADDrxD5tQA440.png')
    background-size 100% 100%
    &::-webkit-scrollbar
      display: none
    .title-img {
      width:  100%;
      height: 200px;
    }
    .title-three {
      display: block;
      width: 375px;
      height: 180px
      margin: 8px auto;
    }
    .title-five {
      display: block;
      width: 375px;
      height: 185px;
      margin: auto;
    }
  main
    padding-bottom 20px

  .invite-btn-box
    padding 10px 0 30px
    text-align: center
    .invite-btn
      display: inline-block
      padding 15px 85px
      background linear-gradient(#FF8820, #FF6B31)
      color #fff
      border 1px solid #FFC040
      border-radius: 25px
      text-align: center
      font-size 18px
      font-weight bold
  .introduction
    position fixed
    top 88px
    right 0
    z-index 9999
    
  footer
    box-sizing: border-box
    position fixed
    left 0
    bottom 0
    z-index 999
    padding 0 10px
    height 64px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    background-color #fff

    .footer-btn
      padding 10px 20px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    .plain
      color $mainTextColor
      background-color: #fff

</style>
